<template>
  <yiban-tool :flow="flow"> </yiban-tool>
</template>
<script>
import yibanTool from "./yibanTool.vue";
export default {
  components: { yibanTool },
  data() {
    return {
      flow: {
          id: "1620714615765766145",
          name: "高危作业",
          name1: "高危待办处理",
        },
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/yhgl/yibanchuligaowei.vue